import React from "react";
import SubPageLayout from "../components/SubPageLayout";
import Admissions from "../components/Admissions";
import ScheduleVisit from "../components/ScheduleVisit";
import { ShapeRainbow, ShapeFlower } from "../components/brand/Shapes";

export default function AdmissionsPage() {
  return (
    <SubPageLayout
      eyebrow="Admissions 2026 — 27"
      title={<>Begin the <span className="italic font-normal">Naavi journey</span>.</>}
      subtitle="Our process is unhurried on purpose — we want to know your child and for you to know us. Four gentle steps, no pressure, no queues."
      accent="cornflower"
      decor="square"
    >
      <div id="process" />
      <div id="enquiry" />
      <Admissions />

      {/* Schedule-a-Visit hero band */}
      <section
        id="visit"
        className="relative pt-14 md:pt-24 pb-6 bg-[#FAFAF5] scroll-mt-32"
        data-testid="visit-intro"
      >
        <ShapeFlower
          size={120}
          color="#C6D947"
          className="absolute top-10 right-[6%] floaty hidden lg:block opacity-90"
        />
        <ShapeRainbow
          size={120}
          color="#5BC4B8"
          className="absolute bottom-2 left-[5%] floaty hidden lg:block opacity-90"
        />
        <div className="max-w-7xl mx-auto px-5 md:px-8 text-center relative">
          <span className="text-xs font-bold tracking-[0.22em] uppercase text-[#648DE5] mb-5 block">
            Visit the Campus
          </span>
          <h2 className="font-display text-[#0F1B47] text-[32px] md:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-semibold max-w-4xl mx-auto">
            Step into our world.
            <br />
            <span className="italic font-normal">Watch your child come alive</span>.
          </h2>
          <p className="mt-6 text-[#4A5568] text-base md:text-lg leading-relaxed font-light max-w-2xl mx-auto">
            Schedule a personal campus tour with our team. We'll walk you through our
            spaces, curriculum and answer every little question you have.
          </p>
        </div>
      </section>

      <ScheduleVisit hideHeader />
    </SubPageLayout>
  );
}
